import { combineReducers } from 'redux'
import questionsSlice from './questionsSlice'
import presentationSlice from './presentationSlice'

export default combineReducers({
    questions: questionsSlice,
    presentation: presentationSlice,
})
